import { useEffect } from 'react';
import { omit } from '../../utils';

/**
 * Text track change event fired twice
 * looks like select/deselect
 * its not related to track items count.
 * In case any->off/off->any there will be one event.
 * Another note - events are async
 * it means, they might have delay of execution between.
 */
export const useTrackChange = (videoRef, onChange) => {
    useEffect(() => {
        const video = videoRef.current;
        /**
         * Only test case
         * Jest jsdom does not fully implemented textTracks
         * textTracks is a regular JS Array - no `addEventListner` method
         */
        if (!video.textTracks.addEventListener) {
            return;
        }

        let track;
        const getActive = () => [...videoRef.current.textTracks]
            .find((track) => track.mode === 'showing');

        const onTracksChange = omit(() => {
            const activeTrack = getActive();

            track = activeTrack;
            onChange(activeTrack ? activeTrack.language : null);
        }, () => {
            const activeTrack = getActive();

            return activeTrack === track;
        });

        /**
         * API is not stable
         * In case dynamically adding video component
         * textTracks updated a bit later.
         * Component is mounted to dom, track has default attribute
         * but textTracks value is 'disabled'.
         * It might be the reasone of firing change event on initial render - fired once.
         * But we cannot use initial event, because once user select subtitle
         * change event fired twice.
         * Using request animation frame to guarantee text tracks updated.
         */
        requestAnimationFrame(() => {
            track = getActive();

            video.textTracks.addEventListener('change', onTracksChange);
        });

        return () => {
            video.textTracks.removeEventListener('change', onTracksChange);
        };
    }, [videoRef, onChange]);
};
